/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useCallback } from "react";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons components
import componentStyles from "assets/theme/views/admin/react-bs-table";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import BootstrapTable from "react-bootstrap-table-next";
import {
  columnTextField,
  columnPriceField,
  columnNumberField,
  columnDateField,
} from "utils/tables-utils";

import MaskAndValid from "utils/maskAndValid";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

import {
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@material-ui/icons";

import { IsMobile } from "utils/is-mobile";

const useTabStyles = makeStyles({
  ...componentStyles,
  subTabsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "50px 15px 0",
    backgroundColor: "RGBA(255, 193, 197, 0.2)",
    width: "100%",
    borderRadius: ".375rem",
  },
  tab: {
    maxWidth: "max-content",
  },
  back: {
    left: 0,
    marginLeft: 30,
    color: "#493C43",
    fontWeight: 600,
    fontSize: 14,
  },
  table: {
    overflow: "auto",
  },
});

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

function DialogWorkflowProblemDetails({
  orderProblem,
  onClose,
  openDialogDetails,
  searchingProblemOrders,
}) {
  const detailsRef = useRef(null);
  const componentRef = useRef(null);
  const classes = { ...useStyles(), ...useTabStyles() };

  const isMobile = IsMobile();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const fotoProdutoItem = (cell, row) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ImagePlaceholder
          className={classes.img}
          alt="Imagem do item do pedido"
          src={row.Foto}
          width={64}
          widthOnError={40}
          imagePreviewTitle={`Produto ${row.IdProduto}`}
        />
      </div>
    );
  };

  const columnModel = [
    columnTextField(
      {
        dataField: "Consumidor.Nome",
        text: "Cliente",
      },
      true
    ),
    columnTextField(
      {
        dataField: "Consumidor.Cpf",
        text: "CPF",
        align: "center",
        formatter: (params) => {
          return MaskAndValid.maskCPNJCPF(params);
        },
      },
      false
    ),
    columnTextField(
      {
        dataField: "IdPedidoEcommerce",
        text: "Número Pedido",
        align: "center",
      },
      false
    ),
    columnPriceField(
      {
        dataField: "ValorTotalPedido",
        text: "Valor Total",
      },
      true
    ),
    columnTextField(
      {
        dataField: "StatusDescricaoPedEcomm",
        text: "Status Pedido",
        align: "center",
      },
      false
    ),
  ];

  const modelTableItemDetail = [
    {
      dataField: "Foto",
      text: "Imagem",
      headerAlign: "center",
      align: "center",
      sort: false,
      formatter: fotoProdutoItem,
      csvExport: false,
    },
    columnDateField(
      {
        dataField: "DataInclusao",
        text: "Data do Pedido",
      },
      true
    ),
    columnNumberField(
      {
        dataField: "Quantidade",
        text: "Quantidade",
      },
      false
    ),
    columnTextField(
      {
        dataField: "DescricaoProduto",
        text: "Descrição Produto",
        align: "left",
        formatter: (cell) => {
          return <p style={{ whiteSpace: "normal" }}>{cell}</p>;
        },
      },
      false
    ),
  ];

  const expandRow = {
    renderer: (row) => (
      <>
        {row?.Itens?.length !== 0 ? (
          <Grid item xs={10}>
            <ToolkitProvider
              data={row?.Itens}
              keyField={"IdProduto"}
              columns={modelTableItemDetail}
            >
              {(props) => (
                <div>
                  <BootstrapTable
                    classes={classes.table}
                    ref={componentRef}
                    {...props.baseProps}
                    bootstrap4={true}
                    bordered={false}
                    condensed={true}
                    striped={true}
                    hover={true}
                  />
                </div>
              )}
            </ToolkitProvider>
          </Grid>
        ) : (
          <>
            {row?.Itens?.length === 0 && (
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "flex-start" : "center",
                  flexDirection: isMobile ? "column" : "row",
                  marginBottom: "-1rem",
                }}
              >
                <p
                  style={{
                    color: "#DF767D",
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                    marginBottom: isMobile && "-0.2rem",
                  }}
                >
                  Itens indisponíveis para consulta no momento.
                </p>
                <p
                  style={{
                    color: "#DF767D",
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                  }}
                >
                  Tente novamente mais tarde.
                </p>
              </Grid>
            )}
          </>
        )}
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandHeaderColumnRenderer: () => (
      <div
        style={{ cursor: "none" }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {" "}
      </div>
    ),
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <ExpandLessIcon />;
      }
      return <ExpandMoreIcon />;
    },
  };

  return (
    <Dialog open onClose={handleClose} maxWidth="lg">
      <DialogTitle disableTypography id="alert-dialog-title">
        <Typography variant="h2" component="h2">
          Pedidos com Problemas
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent ref={detailsRef} style={{ padding: "0 1.5rem 1.5rem" }}>
        <Grid container>
          <Grid item xs={12}>
            <ToolkitTable
              searched={Boolean(orderProblem)}
              keyField="IdPedidoEcommerce"
              dataTable={orderProblem}
              columnModel={columnModel}
              notFoundTitle="Não foram localizados pedidos."
              notFoundSubtitle=""
              pagination={{
                options: [10, 25, 50, 100],
                defaultOption: 10,
              }}
              bootstrapTableProps={{
                expandRow,
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      {searchingProblemOrders && (
        <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ marginBottom: "0.5rem" }}>Buscando pedidos...</span>
          <LinearProgress />
        </Grid>
      )}
      {orderProblem?.length === 0 && !searchingProblemOrders && (
        <Grid
          container
          style={{ height: "100px", display: "flex", alignItems: "center" }}
        >
          <span style={{ paddingLeft: "50px", fontWeight: "600" }}>
            Não foram localizados pedidos.
          </span>
        </Grid>
      )}
    </Dialog>
  );
}

export { DialogWorkflowProblemDetails };
